import React from 'react';

const FacebookIcon = (): JSX.Element => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
  >
    <path
      d="M26,13.0819C26,5.8544,20.182,0,13,0S0,5.8544,0,13.0819c0,6.5248,4.7533,11.9373,10.9687,12.9181v-9.1405h-3.2993v-3.7776h3.2993v-2.8777c0-3.2791,1.9414-5.094,4.908-5.094,1.4216,0,2.909.2538,2.909.2538v3.2214h-1.6411c-1.6168,0-2.1203,1.0061-2.1203,2.0445v2.453h3.6077l-.5773,3.7776h-3.0222v9.1405c6.2154-.9808,10.9687-6.3933,10.9687-12.9181l-.001-.001Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export default FacebookIcon;
